import React, {useCallback} from 'react'
import styled from '@emotion/styled'

import {Grid} from '@vio/atlas/helpers/Grid'
import {SelectionCard} from '@vio/atlas/SelectionCard'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {RoomConfigType} from '@vio/core/src/room/types/RoomConfiguration'

interface Props {
  isOptimized: boolean
  onChange: (value: boolean) => void
  onSelectionClick?: (selectedOption: RoomConfigType) => void
}

const RadioCardsWrapper = styled(Grid)`
  position: relative;
  z-index: 0;
`

const CardWrapper = styled(Grid)`
  && {
    height: auto;
  }
`

export const RoomConfigSelector = ({
  isOptimized,
  onChange,
  onSelectionClick
}: Props) => {
  const handleOptimizeRadioCardChange = useCallback(() => {
    onChange(true)
    onSelectionClick?.(RoomConfigType.Optimized)
  }, [onChange, onSelectionClick])

  const handleManualRadioCardChange = useCallback(() => {
    onChange(false)
    onSelectionClick?.(RoomConfigType.Manual)
  }, [onChange, onSelectionClick])

  return (
    <RadioCardsWrapper container wrap="no-wrap" spacing="s300">
      <CardWrapper mobileSm="6">
        <SelectionCard
          name="optimizeForBestPrice"
          variant="radio"
          selected={isOptimized}
          onChange={handleOptimizeRadioCardChange}
          title={
            <FormattedMessageWrapper
              dataId="optimizeForBestPrice"
              id="optimizeForBestPrice"
              defaultMessage="Optimize for best price"
            />
          }
        />
      </CardWrapper>
      <CardWrapper mobileSm="6">
        <SelectionCard
          name="configureRoomsManually"
          variant="radio"
          selected={!isOptimized}
          onChange={handleManualRadioCardChange}
          title={
            <FormattedMessageWrapper
              dataId="configureRoomsManually"
              id="configureRoomsManually"
              defaultMessage="Configure rooms manually"
            />
          }
        />
      </CardWrapper>
    </RadioCardsWrapper>
  )
}
